import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const formatLanguage = (language: string) => language.slice(0, 2).toLowerCase() + language.slice(2)

const supportedLangs = ['en', 'es', 'fr', 'it', 'ja', 'pt_BR']

export const i18nInit = async (language: string): Promise<any> => {
  const languageFileName = language.includes('-') ? language.replace('-', '_') : formatLanguage(language)
  let translation = {}
  const defaultLanguage = supportedLangs[0]

  if (supportedLangs.includes(languageFileName)) {
    translation = await import(`../../public/locales/${languageFileName}.json`)
  } else {
    translation = await import(`../../public/locales/${defaultLanguage}.json`)
  }

  const resources = {
    [language]: {
      translation
    }
  }

  return i18n.use(initReactI18next).init({
    resources,
    lng: language,
    load: 'currentOnly',
    fallbackLng: defaultLanguage,
    debug: false,
    interpolation: {
      escapeValue: false
    },
    react: { useSuspense: false }
  })
}

export default i18n
